/**
 * Marking Event Service
 * HTTP operations for marking event catalog
 */

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_GetMarkingEventsOut, MarkingEvent } from './eventType.types';
import { mapMarkingEvents } from './eventType.mapper';

/**
 * Service class for marking event catalog operations
 */
export class MarkingEventService {
  /**
   * Get marking events
   * GET /v{version}/catalog/markingEvents
   */
  async getMarkingEvents(signal?: AbortSignal): Promise<ApiResponse<MarkingEvent[]>> {
    const endpoint = API_CONFIG.ENDPOINTS.CATALOG.MARKING_EVENTS;
    const response = await apiClient.get<LC_GetMarkingEventsOut>(endpoint, { signal });

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    const events = mapMarkingEvents(response.data);
    return { ...response, data: events };
  }
}

export const markingEventService = new MarkingEventService();
